import { motion } from 'motion/react';

import { Button } from '@/components/ui/button';
import { sectionNumber } from '@/lib/utils';

interface CTAProps {
  onPrimaryClick?: () => void;
  /** Button copy; defaults to the signed-out call to action. */
  primaryLabel?: string;
}

/**
 * Closing CTA. Pull-quote style — large italic serif, single button.
 * No colourful gradients, no illustration. The typography carries it.
 */
export function CTA({ onPrimaryClick, primaryLabel = 'Sign in to begin' }: CTAProps) {
  return (
    <section className="relative py-24">
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-2">
          <p className="marginalia">
            <span className="mr-2">{sectionNumber(4)}</span>
            begin
          </p>
        </div>

        <motion.div
          className="col-span-12 md:col-span-10"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-serif text-display-md text-ink">
            A common user,{' '}
            <span className="italic text-graphite">
              without designer or developer knowledge
            </span>
            , can design a website that their actual audience can{' '}
            <span className="italic text-ochre">use</span>.
          </p>

          <p className="mt-8 max-w-xl text-base leading-relaxed text-graphite">
            That is the research question AURA is built to answer.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Button size="lg" onClick={onPrimaryClick}>
              {primaryLabel}
            </Button>
            <a
              href="https://www.linkedin.com/in/sankar4/"
              target="_blank"
              rel="noreferrer noopener"
              className="font-mono text-xs text-graphite underline decoration-graphite/30 underline-offset-4 transition-colors hover:decoration-ochre hover:text-ochre"
            >
              Contact the authors &rarr;
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
